﻿(function() {
  "use strict";

  angular.module("app").controller("ProjectController", ProjectController);

  ProjectController.$inject = ["$scope", "$rootScope", "request", "$timeout", "constants", "projectAnalysis", "pricingHelper", "$stateParams", "$location", "$q", "jobHelper", "featureFlagService"];

  function ProjectController($scope, $rootScope, request, $timeout, constants, projectAnalysis, pricingHelper, $stateParams, $location, $q, jobHelper, featureFlagService) {
    let vm = this

    vm.$onInit = onInit;
    vm.scope = $scope

    vm.constants = constants;
    vm.type = { name: '', workareas: 'Workarea', notes: 'Workarea Notes' };

    if (location.hash.includes('/project-estimate/') || location.hash.includes('/estimates/')) {
      vm.type.name = "estimate";
    } else if (location.hash.includes('/projects/')) {
      vm.type.name = "project";
    }

    vm.project;
    vm.projectAnalysis;
    vm.analyzeAreas = {};
    vm.showAllAnalyzeAreas = true;
    vm.analyzeVisits = {};
    vm.showModal = { // used to hide modals html, in order to gain page load performance
      reportSelectionModal: false, printProjectModal: false, visitsNotesModal: false, receiptModal: false
    };

    vm.showTab = { // used to hide tabs html, in order to gain page load performance
      tabSchedule: false,
      tabScheduleNew: false,
      tabVisits: false,
      tabAnalysis: false,
      tabInvoicing: false,
      tabProposals: false,
      tabJobPlan: false,
      tabWorkareas: false
    };

    vm.jobDetailsEnabled = false
    featureFlagService.jobDetails().then(function (enabled) {
      vm.jobDetailsEnabled = enabled
    })

    vm.jobScheduleEnabled = false
    featureFlagService.jobSchedule().then(function (enabled) {
      vm.jobScheduleEnabled = enabled
    })

    vm.loadProject = loadProject;
    vm.updateProject = updateProject;

    vm.notReviewedState = 1
    vm.reviewedState = 2

    vm.triggerSummariesCounter = 0

    vm.printWorkareas = [];
    vm.printSelection = vm.type.name;

    vm.handleReportPrintClick = handleReportPrintClick;
    vm.showReportSelectionModal = showReportSelectionModal;
    vm.showPrintModal = showPrintModal;

    vm.notificationDuration = 0
    vm.notificationType = ''
    vm.notificationMessage = ''
    vm.notificationOnClose = () => {
      vm.notificationMessage = ''
    }

    function showNotification(duration, type, message) {
      vm.notificationDuration = duration
      vm.notificationType = type
      vm.notificationMessage = message
      vm.notificationNonce = Math.random()
    }

    vm.printProject = printProject;

    vm.switchSection = switchSection;   // sets the section (workareas / visits) used for adding catalog items

    vm.datepickerChange = datepickerChange;

    vm.refreshProjectAnalysis = refreshProjectAnalysis;
    vm.toggleShowAllAnalysisAreas = toggleShowAllAnalysisAreas

    vm.showVisitNotes = showVisitNotes;
    vm.selectVisit = selectVisit;

    vm.expandVisitDetails = expandVisitDetails;
    vm.toggleAnalyzeTaskVisit = toggleAnalyzeTaskVisit;

    vm.transformCustomerQboLinkData = transformCustomerQboLinkData;
    vm.customerLinkedInQbo = customerLinkedInQbo;
    vm.customerUnlinkedFromQbo = customerUnlinkedFromQbo;
    vm.createQboCustomer = createQboCustomer;

    vm.receipts = {
      expanded: false,
      receiptsCount: 0,
      vendorsCount: 0,
      total: 0,
      receipt: undefined,
      vendors: undefined,
      attachments: [],
      refresh: receiptsRefresh,
      updateVendor: receiptsUpdateVendor,
      getAttachments: receiptsGetAttachments,
      showReceipt: showReceipt,
      update: receiptsUpdate
    }

    vm.budgetsForItemTable = []

    $scope.$watch("vm.project", function(value) {
      if (value) {
        vm.project.estimateDate = vm.project.estimateDate ? moment(vm.project.estimateDate).format("MM/DD/YYYY") : null;
        vm.project.soldDate = vm.project.soldDate ? moment(vm.project.soldDate).format("MM/DD/YYYY") : null;
        vm.project.workareas.forEach((workarea, index) => {
          workarea.scheduleDate = moment(workarea.scheduleDate).isValid() ? moment(workarea.scheduleDate).format("MM/DD/YYYY") : null;
        });

        vm.project.initialIsSold = vm.project.sold;
        vm.project.initialStatus = vm.project.status;
        vm.analyzeAreas = {};
        vm.project.workareas.forEach(w => vm.analyzeAreas[w.id] = true);

        refreshVisits()

        $timeout(function() {
          refreshProjectAnalysis();
        });
      }
    });

    function refreshVisits() {
      if (!vm.project?.visits) {
        return
      }

      vm.project.visits
          .forEach(visit => {
            visit.taskIds.forEach(id => {
              let v = vm.analyzeVisits[id];

              if (!v) {
                const workarea = vm.project.workareas.find(a => a.id === id);
                if (!workarea) {
                  console.error(`Unable to find a workarea with id ${id} for visit ${visit.id}`)
                  return
                }

                v = {
                  id: id,
                  name: workarea.name,
                  analyze: true,
                  expanded: false,
                  visits: [],
                  analyzeLength() {
                    return this.visits.filter(visit => visit.analyze).length;
                  }
                }
              };

              vm.analyzeVisits[id] = v;

              const visitKey = `${visit.id}__${id}`;
              let vt = v.visits.find(v => v.id === visitKey);

              if (!vt) {
                vt = {
                  id: visitKey,
                  date: visit.date,
                  time: visit.timesheets.filter(v => v.taskId === id).reduce((t, i) => t += i.time, 0).toFixed(2),
                  price: getVisitActual(visit),
                  billed: visit.billed,
                  analyze: true
                };
                v.visits.push(vt);
              } else {
                vt.price = getVisitActual(visit);
                vt.time = (visit.timesheets.filter(v => v.taskId === id).reduce((t, i) => t += i.time, 0)).toFixed(2);
              }
            });
          });

      vm.analysisVisitData = Object.values(vm.analyzeVisits).flatMap(area =>
        area.visits.map(v => ({
          compoundId: v.id,
          workareaId: area.id,
          date: v.date,
          time: v.time,
          price: v.price,
          billed: v.billed
        }))
      )
    }

    function markFormDirty() {
      if ($scope.projectForm) {
        $scope.projectForm.$setDirty()
        $scope.$emit("form-dirtied")
      }
    }
    vm.markFormDirty = markFormDirty

    // used by push customer to QuickBooks when customer has multiple properties
    vm.initiatePushQboCustomerPromise = initiatePushQboCustomerPromise;
    vm.pushQboCustomerPropertySelected = pushQboCustomerPropertySelected;

    // used by auto downpayment generation toggle to link customer to QuickBooks
    vm.openCustomerLinkQboModal = openCustomerLinkQboModal;
    vm.openSetupLinkCostCode = openSetupLinkCostCode;

    // called when linking cost code to QuickBooks
    vm.linkQboCostCode = linkQboCostCode;

    vm.onProjectStatusChange = onProjectStatusChange
    vm.onProjectCompletedDateChange = onProjectCompletedDateChange

    function onProjectStatusChange(project, newStatus) {
      vm.project = jobHelper.onProjectStatusChange(project, newStatus)
    }

    function onProjectCompletedDateChange(project, newCompletedDate) {
      vm.project = jobHelper.onProjectCompletedDateChange(project, newCompletedDate)
    }

    function onInit() {
      moment.updateLocale('en', {
        calendar: { sameDay: 'L', nextDay: 'L', nextWeek: 'L', lastDay: 'L', lastWeek: 'L' }
      });

      // initialize pricing helper with budget year
      pricingHelper.init(() => onBudgetYearChange());

      loadProject();

      angular.element(document).ready(function() {
        $('a[data-toggle="tab"]').on('click', function(e) {
          const dataTarget = e.target.getAttribute('data-target')
          if (dataTarget === '#tab-analysis') {
            refreshProjectAnalysis(true);
          }

          showTabByDataTarget(dataTarget);
          $(e.target).tab('show');
          updateFocusedViewFromDataTarget(dataTarget)
        });
      });

      $(".modal").on("shown.bs.modal", function(e) {
        const firstInput = $("input", e.target)[0];

        if (firstInput) firstInput.select();
      });

      $(".modal").on("mousedown.dragdismissfix", function(e) {
        $(this).data("mousedownTarget", e.target);
      });

      $(".modal").on("click.dragdismissfix", function(e) {
        if (e.target === this && $(this).data("mousedownTarget") !== this) {
          e.stopImmediatePropagation();
        }
      });
    }

    function loadLists() {
      var params = `?projectType=${vm.constants.projectType.project}&customerId=${vm.project.customer.id}&consults=true`
      request.get($rootScope.apiEndpoint + "/projecttickets/viewdata" + params).then(function(response) {
        vm.costCodesList = response.data.costCodes
        vm.divisionsList = response.data.divisions
        vm.yearlyBudgetsList = response.data.yearlyBudgets
        vm.consultsList = response.data.consults

        vm.estimatorsList = response.data.estimators.filter(x => !x.disabled || x.value === vm.project.estimatorEmail)

        vm.salesPeopleList = response.data.salesPeople.filter(x => !x.disabled || x.value === vm.project.salesPersonEmail)

        var schedulersOnProject = vm.project.schedulers ? vm.project.schedulers.split(", ") : []
        vm.schedulersList = response.data.schedulers.filter(x => !x.disabled || schedulersOnProject.includes(x.value))
      });
    }

    function loadProject() {
      var id = $stateParams.id.split("-")[0];

      request.get(`${$rootScope.apiEndpoint}/jobs/${id}`).then(function(response) {
        vm.project = response.data;
        if (vm.project.visits) {
          vm.project.visits.sort((a, b) => b.date.localeCompare(a.date))
        }

        vm.originalBudgetYear = vm.project.budgetYear
        onBudgetYearChange()

        //setting the route to the previous page when pressing the back arrow in Attachments
        constants.previousRouteAttachments = "#!" + vm.type.name + "s/" + vm.project.url;

        loadLists()

        if (vm.project.schedulers) {
          vm.project.selectedSchedulers = {};
          vm.project.schedulers.split(", ").forEach(s => vm.project.selectedSchedulers[s] = true);
        }

        $timeout(function() {
          if ($scope.projectForm) {
            $scope.projectForm.$setPristine();
          }
        });

      }).catch(error => {
        vm.jobLoadError = (error.data && error.data.message) ? error.data.message : 'There was an error loading this job.'
      });
    }

    function getProjectSchedulersString(project) {
      let schedulers

      if (!project.selectedSchedulers || Object.keys(project.selectedSchedulers).length === 0) {
        schedulers = null;
      } else {
        schedulers = Object.keys(project.selectedSchedulers).filter(s => project.selectedSchedulers[s]).join(", ");
      }

      return schedulers
    }

    /*
        Function called on project save, before validating project.
        Prepares project object for validation and saving.
    */
    function processProjectOnSave(project) {
      project.schedulers = getProjectSchedulersString(project)
    }

    /*
        Function called on project save.
        Validates conditions for project saving and displays appropriate alerts.
        Returns true if project is valid.
    */
    function validateProjectOnSave(project) {
      let valid = true;

      //No sold flag without at least one scheduler notification
      if (project.sold && !project.schedulers) {
        showNotification(5, 'Info', "Before marking this project as sold, please select at least one scheduler to notify.")
        valid = false;
      }

      return valid;
    }

    vm.Updater = () => {

      if (vm.isProjectSaving) {
        return
      }

      vm.isProjectSaving = true
      updateProject()
    }

    /*
        Saves project to database.
        Returns true if project got saved, false otherwise.
    */
    async function updateProject(forceItemSave = false) {
      var isProjectSaved = false

      processProjectOnSave(vm.project)

      if (!validateProjectOnSave(vm.project)) {
        vm.isProjectSaving = false
        return isProjectSaved
      }

      vm.project.workareas.sort((a, b) => a.sortIndex - b.sortIndex)

      vm.originalBudgetYear = vm.project.budgetYear

      var saveData = { ...vm.project }
      if (!forceItemSave) {
        saveData.workareas = []
        saveData.bundles = []
        saveData.visits = []
        saveData.itemsChangeSet = null
      }
      else {
        saveData.itemsChangeSet = buildItemsChangeSetForPost()
      }

      await request.post($rootScope.apiEndpoint + '/jobs', saveData).then(function(response) {
        updateIntercomSaveProject();
        isProjectSaved = true
        vm.project = response.data;

        if (vm.project.schedulers) {
          vm.project.selectedSchedulers = {};
          vm.project.schedulers.split(", ").forEach(s => vm.project.selectedSchedulers[s] = true);
        }

        $timeout(function() {
          vm.itemsContextSaveCounter++
          $scope.$apply();
          $scope.projectForm.$setPristine();
        });
        vm.isProjectSaving = false
      }, function(e) {
        vm.isProjectSaving = false
        console.log(e)
        showNotification(5, 'Error', "There was an error updating the project")
      });

      return isProjectSaved
    }

    function updateIntercomSaveProject() {
      var statuses = ["Unscheduled", "Scheduled", "Waiting", "Completed"];
      var metadata = {
        name: vm.project.name,
        customer: vm.project.customer.displayName,
        property: vm.project.property.displayName,
        total_workareas: vm.project.workareas.length,
        estimated_price: ((vm.projectAnalysis?.estimated?.price ?? 0) / 100).toFixed(2),
        estimated_hours: vm.projectAnalysis?.estimated?.hours ?? 0,
        salesperson: vm.project.salesPersonName,
      };
      if (vm.project.status) {
        metadata["status"] = statuses[vm.project.status];
      } else {
        metadata["status"] = "Unscheduled";
      }

      if (vm.project.sold && vm.project.sold != vm.project.initialIsSold) {
        metadata["sold_date"] = new Date();
        window.Intercom("trackEvent", "sold-project", metadata);
      }
      if (vm.project.status == 3 && vm.project.initialStatus != 3) {
        metadata["final_price"] = ((vm.projectAnalysis?.final?.price ?? 0) / 100).toFixed(2);
        window.Intercom("trackEvent", "completed-project", metadata);
      }
      if (vm.project.url.includes("new")) {
        window.Intercom("trackEvent", "saved-new-project", metadata);
      }
    }

    async function handleReportPrintClick() {
      var isProjectSaved = $scope.projectForm.$dirty ? await updateProject() : true
      if (isProjectSaved)
        showReportSelectionModal()
    }

    function showReportSelectionModal() {
      showModalById("report-selection-modal");
    }

    function showPrintModal() {
      switch (vm.printSelection) {
        case 'project':
          showProjectReportModal();
          break;
        case 'itemsSummary':
          $timeout(function() {
            $(".btn-items-summary").trigger('click');
          });
          break;
      }
    }

    function selectItemsSummary() {
      if (vm.printSelection != 'itemsSummary') {
        vm.printSelection = 'itemsSummary'
        $timeout(function() {
          $(".btn-items-summary").trigger('click');
        }, 250)
      }
    }
    vm.selectItemsSummary = selectItemsSummary
    vm.selectItemsSummaryFromReact = function() {
      selectItemsSummary()
      $scope.$apply()
    }

    function showProjectReportModal() {
      vm.printWorkareas = vm.project.workareas.map(function(value) {
        return { id: value.id, name: value.name, isOnHold: value.isOnHold, print: !value.isOnHold };
      });

      showModalById("print-project-modal");
    }

    function printProject() {
      var data = {}
      vm.printWorkareas.forEach(area => {
        data[`print-area-${area.id}`] = area.print
      })

      request.post(`${$rootScope.apiEndpoint}/${vm.type.name}s/${vm.project.url}/print/upload`, data)
        .then(function(response) {
          window.open(response.data.url, "_blank");

        }, function(e) {
          console.log(e);
          showNotification(5, 'Error', "There was an error printing.")
        });

      $("#print-project").modal('hide');
    }

    vm.linkCustomerToQbo2 = () => {
      openCustomerLinkQboModal(false)
    }
    vm.linkCostCodeToQbo2 = (costCodeId) => {
      openSetupLinkCostCode(costCodeId, false)
    }

    function datepickerChange(newValue) {
      markFormDirty()
    }

    function refreshAttachments() {
      const receiptsVisible = document.querySelector('#receipt-modal').classList.contains('in');

      if (receiptsVisible) {
        receiptsGetAttachments();
      }

      request.get($rootScope.apiEndpoint + "/attachments/properties/" + vm.project.property.id + "/count?jobId=" + vm.project.id).then(function(response) {
        vm.project.attachments = response.data;
      });
    }

    function switchSection(newSection) {
      updateFocusedViewFromSection(newSection)
    }

    function toggleShowAllAnalysisAreas() {
      Object.keys(vm.analyzeAreas).forEach(key => vm.analyzeAreas[key] = vm.showAllAnalyzeAreas)
      refreshProjectAnalysis(true)
    }

    function refreshProjectAnalysis(refreshAll = false) {
      vm.showAllAnalyzeAreas = Object.values(vm.analyzeAreas).every(x => !!x)
      vm.projectAnalysis = projectAnalysis.refreshFromReactWorkareaSummaries(itemsContextWorkareaSummaries)

      vm.receipts.refresh();

      const activeTab = document.querySelector('#nav-section li.active a').getAttribute('data-target');

      if (activeTab === '#tab-analysis' || refreshAll) {
        let visitIds, workareaIds;

        if (vm.analyzeAreas) {
          workareaIds = Object.entries(vm.analyzeAreas).filter(a => a[1]).map(a => parseInt(a[0]));
        }

        if (vm.analyzeVisits) {
          visitIds = [];
          Object.values(vm.analyzeVisits)
            .filter(av => vm.analyzeAreas[av.id])
            .forEach(av => {
              visitIds.push(...av.visits
                .filter(v => v.analyze)
                .map(v => v.id)
              );
            });
        }
      }

      refreshEnabledWorkareasAndVisits()

      $timeout(function() { $scope.$apply(); });
    }

    function getVisitActual(visit) {
      if (!visit) return;

      if (itemsContextVisitSummary) {
        const summary = itemsContextVisitSummary.find(x => x.visitId === visit.id)
        if (summary) {
          return summary.totalPrice
        }
      }

      return 0
    }

    function showVisitNotes() {
      showModalById("visits-notes-modal");
    }

    function selectVisit(visit) {
      vm.project.visits.forEach(v => v.expanded = v === visit);

      $('#visits-notes-modal').modal('hide');
      $("#nav-section a[data-target='#tab-visits']").tab('show');
      $timeout(() => {
        document.querySelector(`[data-visit-id='${visit.id}']`).scrollIntoView();
        window.scrollBy(0, -100);
      }, 500);
    }

    function expandVisitDetails(taskId) {
      if (taskId) {
        vm.analyzeVisits[taskId].expanded = !vm.analyzeVisits[taskId].expanded;
      }

      Object.values(vm.analyzeVisits).filter(v => v.expanded && v.id !== taskId).forEach(v => v.expanded = false);
    }

    function toggleAnalyzeTaskVisit(taskId, visit) {
      const task = vm.analyzeVisits[taskId];

      if (taskId && !visit) {
        task.visits.forEach(visit => visit.analyze = task.analyze);
      }

      if (visit) {
        task.analyze = task.visits.every(visit => visit.analyze);
      }

      refreshProjectAnalysis();
    }

    vm.onInvoicesChanged = function() {
      loadProject();
      setTimeout(() => {
        vm.itemsContextSaveCounter++
        $scope.$apply()
      }, 0)
    }

    // function used by the link-qbo-entity component
    // to transform the data which is posted to the update endpoint [to update the qboId property in the db]
    function transformCustomerQboLinkData(data) {
      return { id: vm.project.customer.id, qboId: data.id, qboDisplayName: data.displayName };
    }

    // function called after the customer has been successfully linked from the link-qbo-entity component
    // to update the view model
    function customerLinkedInQbo(data) {
      vm.project.customer.qboId = data.qboId;
      vm.project.customer.qboDisplayName = data.qboDisplayName;
    }

    // function called after the customer has been successfully unlinked from the link-qbo-entity component
    // to update the view model
    function customerUnlinkedFromQbo() {
      vm.project.customer.qboId = null;
      vm.project.customer.qboDisplayName = null;
    }

    //Receipt functions
    function receiptsRefresh() {
      if (!vm.project || !vm.project.receipts) return;

      vm.receipts.receiptsCount = vm.project.receipts.length;
      vm.receipts.vendorsCount = vm.project.receipts.reduce((t, v) => t.add(v.vendorId), new Set()).size;

      vm.project.receipts = [...vm.project.receipts]
    }

    function receiptsRemove(event, receipt) {
      receipt.removed = !receipt.removed;
      event.stopPropagation();
      markFormDirty()
    }

    function receiptsUpdateVendor() {
      const vendorName = document.querySelector('#receipt-edit__vendor').selectedOptions[0].text;
      vm.receipts.receipt.vendorName = vendorName;
    }

    async function receiptsGetAttachments() {
      try {
        const { data } = await request.get($rootScope.apiEndpoint + `/attachments/properties/${vm.project.propertyId}`)
        vm.receipts.attachments = data
          .filter((attachment) => attachment.folder === decodeURIComponent(window.encodeURIComponent(vm.project.defaultAttachmentFolder)))
          .filter((x) => x.name.includes(vm.receipts.receipt.receiptNumber) || x.tags.includes(vm.receipts.receipt.receiptNumber))
        $scope.$apply();

      } catch (e) {
        console.log(e);
      }
    }

    function showReceipt(receipt) {
      if (!vm.receipts.vendors) {
        //vendors hasn't been loaded from api yet
        request.get($rootScope.apiEndpoint + '/vendors/active').then(response => vm.receipts.vendors = response.data);
      };

      if (!receipt) {
        receipt = {
          id: -(vm.project.receipts.length + 1),
          projectId: vm.project.id,
          vendorId: null,
          receiptDate: moment().format("MM/DD/YYYY")
        };
      }

      vm.receipts.receipt = receipt;
      vm.receipts.receipt.receiptDate = vm.receipts.receipt.receiptDate ? moment(vm.receipts.receipt.receiptDate).format("MM/DD/YYYY") : null;

      receiptsGetAttachments();

      switchSection('receipt');
      showModalById("receipt-modal");
    }

    function receiptsUpdate() {
      if (!vm.project.receipts.includes(vm.receipts.receipt)) {
        vm.project.receipts.push(vm.receipts.receipt);
      }
      receiptsRefresh()
      updateProject(true)
    }

    function showModalById(modalId) {
      //sets the condition to display the modal to true
      vm.showModal[convertToCamelCase(modalId)] = true;
      $timeout(function() {
        $("#" + modalId).modal();
      });
    }

    function showTabByDataTarget(dataTarget) {
      if (dataTarget) {
        vm.showTab[convertToCamelCase(dataTarget.substring(1))] = true;
      }
      $scope.$apply();
    }

    function convertToCamelCase(stringToConvert) {
      //converts string like this "report-selection-modal" to a string like this "reportSelectionModal"
      var arrString = stringToConvert.split("-");
      var result = arrString[0];
      for (var i = 1; i < arrString.length; i++) {
        result = result.concat(arrString[i].charAt(0).toUpperCase() + arrString[i].substring(1));
      }
      return result;
    }

    /* used when the QuickBooks linking pop is opened
     * initiates the linking promise to the QuickBooks component
     */
    function initiatePushQboCustomerPromise() {
      vm.pushQboCustomerDefer = $q.defer();
    }

    /* used when pushing customer to QBO, ONLY IF the customer has multiple properties
     * this is used to allow user to select target property
     */
    function pushQboCustomerPropertySelected() {
      vm.isPushQboCustomerPropertySelected = true;
      createQboCustomer();
    }

    /* function called when creating QuickBooks customer from Synked customer
     */
    function createQboCustomer() {
      var apiUrl = `/quickbooks/customer?id=${vm.project.customer.id}`;

      // if customer has more properties, override method to first select the target property
      if (vm.project.customer.properties > 1) {
        if (!vm.isPushQboCustomerPropertySelected) {
          $(".modal").modal("hide");
          vm.selectedPushQboCustomerProperty = vm.project.customer.propertyList[0];
          $("#select-property-qbo-create-customer").modal();

          // return unresolved promise, to allow user select the customer property
          return vm.pushQboCustomerDefer.promise;
        }
        else {
          // if target property was selected, add to apiUrl as param
          apiUrl += vm.selectedPushQboCustomerProperty ? `&selectedPropertyId=${vm.selectedPushQboCustomerProperty.id}` : '';
        }
      }

      // finally, push the customer to QBO
      request.post($rootScope.apiEndpoint + apiUrl).then(function(result) {
        vm.project.customer.qboId = result.data.entity.id;
        vm.project.customer.qboDisplayName = result.data.entity.displayName;
        vm.isPushQboCustomerPropertySelected = false;
        vm.pushQboCustomerDefer.resolve({ id: vm.project.customer.id, qboId: result.data.entity.id, qboDisplayName: result.data.entity.displayName });

      }, function(e) {
        vm.pushQboCustomerDefer.reject(e);
      });

      if (vm.pushQboCustomerDefer) {
        return vm.pushQboCustomerDefer.promise
      } else {
        return
      }
    }

    // used by auto downpayment generation toggle to link customer to qbo
    function openCustomerLinkQboModal() {
      $timeout(function() {
        document.getElementsByClassName('link-qbocustomer')[0].click()
      });
    }

    function openSetupLinkCostCode(costCodeId) {
      vm.selectedQboCostCodeToLink = costCodeId;
      vm.linkQboEntity.show();
    }

    vm.reactCostCodeRefreshCounter = 0

    // function valled when linking cost code to qbo
    function linkQboCostCode(data, updateDetails) {
      var costCode = updateDetails ? { id: vm.selectedQboCostCodeToLink, qboId: data.id, qboDisplayName: data.displayName } : { id: vm.selectedQboCostCodeToLink, qboId: data.id }
      request.post($rootScope.apiEndpoint + "/costcodes/qbo", costCode).then(function() {
        vm.reactCostCodeRefreshCounter++
      }, function(e) {
        showNotification(5, 'Error', "Failed to link cost code to QuickBooks")
      });
    }

    vm.onBudgetYearChange = onBudgetYearChange
    function onBudgetYearChange() {
      if (vm.project) {
        vm.budgetsForItemTable = pricingHelper.getBudgetsForYear(vm.project.budgetYear)
      }
    }

    vm.templateAddedFromItemTable = templateAddedFromItemTable
    function templateAddedFromItemTable(workareaId, template) {
    }

    vm.setReceiptCustomTotal = setReceiptCustomTotal
    function setReceiptCustomTotal(customTotal) {
      vm.receipts.receipt.customTotal = customTotal
      $scope.$apply()
    }

    let itemsContextChangeSet
    let itemsContextVisitSummary
    let itemsContextWorkareaSummaries = []

    vm.onItemsContextChange = onItemsContextChange
    function onItemsContextChange(changeSet, visitSummary, workareaSummaries) {
      itemsContextChangeSet = changeSet
      itemsContextVisitSummary = visitSummary
      itemsContextWorkareaSummaries = workareaSummaries

      refreshVisits()

      if (workareaSummaries.length > 0) {
        refreshProjectAnalysis()
      }
      if (itemsContextChangeSet.addedItems.length > 0 || itemsContextChangeSet.updatedItems.length > 0 || itemsContextChangeSet.deletedItems.length > 0) {
        markFormDirty()
      }
    }

    vm.itemsContextSaveCounter = 0

    function buildItemsChangeSetForPost() {
      const isWorkareaValid = (addedItem) => {
        const workarea = vm.project.workareas.find(x => x.id === addedItem.workareaId)
        return workarea && !workarea.removed
      }

      if (!itemsContextChangeSet) {
        return {
          addedEstimatedItems: [],
          addedActualItems: [],
          updatedEstimatedItems: [],
          updatedActualItems: [],
          deletedItems: []
        }
      }

      return {
        addedEstimatedItems: itemsContextChangeSet.addedItems.filter(x => isEstimatedItem(x) && !itemsContextChangeSet.deletedItems.includes(x.guid) && isWorkareaValid(x)),
        addedActualItems: itemsContextChangeSet.addedItems.filter(x => !isEstimatedItem(x) && !itemsContextChangeSet.deletedItems.includes(x.guid)),
        updatedEstimatedItems: itemsContextChangeSet.updatedItems.filter(x => isEstimatedItem(x)),
        updatedActualItems: itemsContextChangeSet.updatedItems.filter(x => !isEstimatedItem(x)),
        deletedItems: itemsContextChangeSet.deletedItems
      }
    }

    function isEstimatedItem(item) {
      return item.isAdditional === undefined
    }

    vm.receiptClick = function(id) {
      vm.receipts.showReceipt(vm.project.receipts.find(x => x.id === id))
    }

    vm.receiptDelete = function(e, id) {
      receiptsRemove(e, vm.project.receipts.find(x => x.id === id))
      vm.project.receipts = [...vm.project.receipts]
      $scope.$apply()
    }

    vm.enabledWorkareaIds = []
    vm.visitFilters = []

    function refreshEnabledWorkareasAndVisits() {
      vm.enabledWorkareaIds = Object.entries(vm.analyzeAreas).filter(([_, v]) => !!v).map(([k, _]) => parseInt(k))
      vm.visitFilters = Object.values(vm.analyzeVisits).flatMap(x => x.visits).map(x => ({compoundId: x.id, include: !!x.analyze}))
    }

    vm.onAnalysisFilterChange = function(enabledWorkareaIds, visitFilters) {
      console.log('enabledWorkareaIds', enabledWorkareaIds)
      console.log('visitFilters', visitFilters)
      vm.enabledWorkareaIds = enabledWorkareaIds
      vm.visitFilters = visitFilters

      if (vm.analyzeAreas) {
        Object.keys(vm.analyzeAreas).forEach(key => {
          vm.analyzeAreas[key] = enabledWorkareaIds.includes(parseInt(key))
        })
      }

      if (vm.analyzeVisits) {
        const visitFilterMap = {}
        visitFilters.forEach(vf => { visitFilterMap[vf.compoundId] = vf.include })
        Object.values(vm.analyzeVisits).forEach(area => {
          area.visits.forEach(v => {
            if (visitFilterMap[v.id] !== undefined) {
              v.analyze = visitFilterMap[v.id]
            }
          })
          area.analyze = area.visits.every(v => v.analyze)
        })
      }

      vm.projectAnalysis = projectAnalysis.refreshFromReactWorkareaSummaries(itemsContextWorkareaSummaries)
      $scope.$apply()
    }

    vm.itemsContextFocusedView = 'workarea-estimated'

    function updateFocusedViewFromDataTarget(dataTarget) {
      var previousValue = vm.itemsContextFocusedView
      switch (dataTarget) {
        case '#estimated-items':
        case '#tab-job-plan':
          vm.itemsContextFocusedView = 'workarea-estimated'
          break
        case '#actual-items':
          vm.itemsContextFocusedView = 'workarea-actual'
          break
        case '#tab-visits':
          vm.itemsContextFocusedView = 'visits'
          break
        case '#tab-analysis':
          vm.itemsContextFocusedView = 'costing-and-analysis'
          break
        case '#tab-invoicing':
          vm.itemsContextFocusedView = 'invoicing'
          break;
        case '#tab-details':
        case '#tab-proposals':
        case '#tab-schedule':
        case '#tab-schedule-new':
          break
        default:
          console.log('unhandled dataTarget', dataTarget)
          break
      }

      if (vm.itemsContextFocusedView !== previousValue) {
        setTimeout(() => $scope.$apply(), 0)
      }
    }

    function updateFocusedViewFromSection(section) {
      var previousValue = vm.itemsContextFocusedView
      switch (section) {
        case 'visits':
          vm.itemsContextFocusedView = 'visits'
          break
        case 'comparative':
          vm.itemsContextFocusedView = 'costing-and-analysis'
          break
        case 'receipt':
          vm.itemsContextFocusedView = 'receipt'
          break
        default:
          console.log('unhandled section', section)
          break
      }

      if (vm.itemsContextFocusedView !== previousValue) {
        setTimeout(() => $scope.$apply(), 0)
      }
    }

    const isFormDirty = () => $scope.projectForm && $scope.projectForm.$dirty
    vm.isFormDirty = isFormDirty

    vm.attachmentUploadVisible = false
    vm.attachmentDefaultFileName = undefined
    vm.attachmentContainerId = undefined

    vm.showAttachmentUpload = function showAttachmentUpload() {
      vm.attachmentDefaultFileName = undefined
      vm.attachmentContainerId = undefined
      vm.attachmentUploadVisible = true
    }

    vm.showReceiptAttachmentUpload = function showReceiptAttachmentUpload() {
      vm.attachmentDefaultFileName = `${vm.receipts.receipt.vendorName} ${vm.receipts.receipt.receiptNumber}`.trim()
      vm.attachmentContainerId = 'receipt-modal'
      vm.attachmentUploadVisible = true
    }

    vm.onAttachmentUploadClose = function onAttachmentUploadClose() {
      vm.attachmentUploadVisible = false
      refreshAttachments()
      setTimeout(() => $scope.$apply(), 1)
    }

    vm.hasActiveAutomation = false
    vm.handleAutomationChange = (active) => {
      if (vm.hasActiveAutomation != active) {
        vm.hasActiveAutomation = active
        setTimeout(() => $scope.$apply(), 1)
      }
    }

    vm.onJobPlanWorkareaChanges = (updatedWorkareaGroups) => {
      updatedWorkareaGroups.forEach(workareaGroup => {
        workareaGroup.workareas.forEach(update => {
          const workarea = vm.project.workareas.find(x => x.id === update.id)
          if (workarea) {
            workarea.workareaGroupId = update.workareaGroupId
            workarea.name = update.name
            workarea.master = update.master
            workarea.masterWorkareaId = update.masterWorkareaId
            workarea.sortIndex = update.sortIndex
            workarea.quotedPrice = update.quotedPrice
            workarea.customQuotedPrice = update.customQuotedPrice
            workarea.status = update.status
            workarea.divisionId = update.divisionId
            workarea.costCodeId = update.costCodeId
            workarea.notes = update.notes
            workarea.customLaborRateItemId = update.customLaborRateItemId
            workarea.showTaxInFinalPrice = update.showTaxInFinalPrice
            workarea.completedDate = update.completedDate
            workarea.recurringScheduleConfig = update.recurringScheduleConfig
            workarea.pricingType = workareaGroup.pricingType
            workarea.isApproved = workareaGroup.isApproved
            workarea.isOnHold = workareaGroup.isOnHold
            workarea.customerAndInvoiceNotes = update.customerAndInvoiceNotes
            workarea.invoiceDescription = update.invoiceDescription
            workarea.estimatedOccurrences = update.estimatedOccurrences
            return
          }

          vm.project.workareas.push({
            ...update,
            scheduleDate: '',
            hours: 0,
            alreadyInvoiced: 0,
            pricingType: workareaGroup.pricingType,
            isApproved: workareaGroup.isApproved,
            isOnHold: workareaGroup.isOnHold
          })
        })
      })

      var workareaIdsToKeep = updatedWorkareaGroups.flatMap(x => x.workareas.map(w => w.id))
      vm.project.workareas = vm.project.workareas.filter(x => workareaIdsToKeep.includes(x.id))
      vm.triggerSummariesCounter++
      $timeout(function() { $scope.$apply(); })
    }

    vm.addVisit = function addVisit() {
      vm.showNewVisitModal = true;
      vm.editVisitId = null;
      $scope.$apply()
    }

    vm.editVisit = function editVisit(visitId) {
      vm.showNewVisitModal = true;
      vm.editVisitId = visitId;
      $scope.$apply()
    }

    vm.closeVisitModal = function closeVisitModal() {
      vm.showNewVisitModal = false
      vm.loadProject()
      $scope.$apply()
    }
  }
})();
